class AppEvent extends EventTarget {
  constructor() {
    super()
  }

  error401() {
    this.dispatchEvent(new Event('error401'))
  }

  error403() {
    this.dispatchEvent(new Event('error403'))
  }

  errorNetwork() {
    this.dispatchEvent(new Event('errorNetwork'))
  }

  userLoggedIn() {
    this.dispatchEvent(new Event('userLoggedIn'))
  }

  teamChanged(skipNavigation = false) {
    this.dispatchEvent(new CustomEvent('teamChanged', { detail: { skipNavigation } }))
  }

  teamDataLoaded() {
    this.dispatchEvent(new Event('teamDataLoaded'))
  }

  reloadMethodology() {
    this.dispatchEvent(new Event('reload-methodology'))
  }

}

export const appEventInstance = new AppEvent()
